import React from 'react';
import { Calendar } from './svg/Calendar';
import { Note } from './svg/Note';
import { Search } from './svg/Search';
import { SearchEntry } from './svg/SearchEntry';
import { Document } from './svg/Document';
import { Entry } from './svg/Entry';

interface IGraphicProps {
    variant: image.SvgVariants;
}

export const Graphic = ({ variant }: IGraphicProps) => {
    return (
        <>
            {variant === 'Calendar' && <Calendar />}
            {variant === 'Document' && <Document />}
            {variant === 'Note' && <Note />}
            {variant === 'Search' && <Search />}
            {variant === 'SearchEntry' && <SearchEntry />}
            {variant === 'Entry' && <Entry />}
        </>
    );
};
